import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ItemNumberToFilterShared } from '../../../models/interface/itemNumberToFilter.interface';
import { Filters } from '../../../types/filters.type';

@Component({
  selector: 'app-mu-multiselect',
  templateUrl: './mu-multiselect.component.html',
  styleUrls: ['./mu-multiselect.component.sass'],
})
export class MuMultiselectComponent<TargetFilters> implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() muFormControlName: string;
  @Input() filter: boolean;
  @Input() options: ItemNumberToFilterShared[];
  @Input() showToggleAll: boolean;
  @Input() resetFilterOnHide: boolean;
  @Input() filterList: Filters<TargetFilters>;
  @Input() filterName: string;
  @Input() placeholder: string;
  @Input() filterBy: string = 'label';
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  @Input() manySelectedLabel: string;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * @param  {number} optionId
   * @returns string the name translated
   */
  getLabelById(optionId: number): string {
    if (optionId === null || optionId === undefined || !this.options) {
      return '';
    }
    return this.options.find(r => r.value === optionId)?.label || '';
  }

  /**
   * return placeholder when no items are selected
   * @returns
   */
  getPlaceHolder(): string {
    return this.placeholder ? this.placeholder : 'multiSelect.select';
  }

  /**
   * return label when many items are selected
   * @returns
   */
  getManySelectedLabel(): string {
    if (this.manySelectedLabel) {
      return this.manySelectedLabel;
    }
    return 'multiSelect.selected';
  }
}
